import styled from 'styled-components';

const HeaderWrap = styled.div`
  padding: 10px;
`;

export default HeaderWrap;
